import { Injectable } from '@angular/core';
import { HttpDataService, IHttpDataCache } from '../../../../../shared/http/http-data.service';
import { LOV_COUNTRY, LovService } from '../../../../../shared/services/lov.service';
import { ICompanyGroup, ICountry } from '../../../../../../type_definitions/datatypes';


@Injectable()
export class CustomerDataService {
  private cache:IHttpDataCache<any>;

  constructor(
    private httpDataService:HttpDataService,
    private lovService:LovService
  ) {
    this.cache = httpDataService.createCache();
  }

  public LAMGroups():Promise<ICompanyGroup[]> {
    return this.cache.doGET('rest/compman/activelamcompanygroups', undefined, undefined, 'Error loading LAM Groups');
  }

  public countries():Promise<ICountry[]> {
    return this.lovService.list(LOV_COUNTRY);
  }

  public clear() {
    this.cache.clear();
  }
}